import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent } from './exercises/exercises.component';
import { TopicComponent } from './topic/topic.component';
import { TeacherGuard } from '../App/teacher-guard.service';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import { TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';

import { TColoredFlagsComponent } from './t-colored-flags/t-colored-flags.component';
import { ColoredFlagsComponent } from './colored-flags/colored-flags.component';
import { TAllWordsComponent } from './t-all-words/t-all-words.component';
import { AllWordsComponent } from './all-words/all-words.component';

import { AllWordsMultComponent } from './all-words-mult/all-words-mult.component';
import { TAllWordsMultComponent } from './t-all-words-mult/t-all-words-mult.component';

import { AllColorsMultComponent } from './all-colors-mult/all-colors-mult.component';
import { TAllColorsMultComponent } from './t-all-colors-mult/t-all-colors-mult.component';



const routes: Routes = [
  {
    path: 'listingWithTreeDiagrams', component: TopicComponent,
    children: [
      { path: '', component: ExercisesComponent, pathMatch: 'full' },
      { path: 'exam/:id', component: ExamComponent },
      { path: 'exam/:id/evaluation', component: EvaluationComponent },
      { path: 'exam/:examid/openQuestion/:id', component: OpenQuestionComponent },
      { path: 'exam/:examid/multipleChoice/:id', component: MultipleChoiceComponent },
      { path: 'openQuestion/:id', component: OpenQuestionComponent },
      { path: 'multipleChoice/:id', component: MultipleChoiceComponent },
      
      { path: 'coloredFlags/:id', component: ColoredFlagsComponent },
      { path: 'exam/:examid/coloredFlags/:id', component: ColoredFlagsComponent },

      { path: 'allWords/:id', component: AllWordsComponent },
      { path: 'exam/:examid/allWords/:id', component: AllWordsComponent },


      { path: 'allWordsMult/:id', component: AllWordsMultComponent},
      { path: 'exam/:examid/allWordsMult/:id', component: AllWordsMultComponent },

      { path: 'allColorsMult/:id', component: AllColorsMultComponent},
      { path: 'exam/:examid/allColorsMult/:id', component: AllColorsMultComponent },

    ]
  },
  {
    path: 'teacher/listingWithTreeDiagrams', canActivate: [TeacherGuard], canActivateChild: [TeacherGuard], component: TopicComponent,
    children: [
      { path: '', component: TExercisesComponent, pathMatch: 'full' },
      { path: 'openQuestion', component: TOpenQuestionComponent },
      { path: 'multipleChoice', component: TMultipleChoiceComponent },
      { path: 'openQuestion/:id', component: TOpenQuestionComponent },
      { path: 'multipleChoice/:id', component: TMultipleChoiceComponent },
      { path: 'allExercisesTeacher', component: TAllExercisesComponent },
      { path: 'allExamsTeacher', component: TAllExamsComponent },
      
      { path: 'coloredFlags', component: TColoredFlagsComponent },
      { path: 'allWords', component: TAllWordsComponent },
      { path: 'allWordsMult', component: TAllWordsMultComponent},
      { path: 'allColorsMult', component: TAllColorsMultComponent},


      { path: 'coloredFlags/:id', component: TColoredFlagsComponent },
      { path: 'allWords/:id', component: TAllWordsComponent },
      { path: 'allWordsMult/:id', component: TAllWordsMultComponent},
      { path: 'allColorsMult/:id', component: TAllColorsMultComponent},

      { path: 'exam', component: TExamComponent },
      { path: 'exam/:examid', component: TExamComponent, pathMatch: 'full' },
      { path: 'exam/:examid/allExercisesTeacher', component: TAllExercisesComponent },
      { path: 'exam/:examid/openQuestion', component: TOpenQuestionComponent },
      { path: 'exam/:examid/openQuestion/:id', component: TOpenQuestionComponent },

      { path: 'exam/:examid/multipleChoice', component: TMultipleChoiceComponent },
      { path: 'exam/:examid/multipleChoice/:id', component: TMultipleChoiceComponent },
     
      { path: 'exam/:examid/coloredFlags', component: TColoredFlagsComponent },
      { path: 'exam/:examid/coloredFlags/:id', component: TColoredFlagsComponent },
      
      { path: 'exam/:examid/allWordsMult', component: TAllWordsMultComponent},
      { path: 'exam/:examid/allWordsMult/:id', component: TAllWordsMultComponent},
      
      { path: 'exam/:examid/allColorsMult', component: TAllColorsMultComponent},
      { path: 'exam/:examid/allColorsMult/:id', component: TAllColorsMultComponent},


      { path: 'exam/:examid/allWords', component: TAllWordsComponent },
      { path: 'exam/:examid/allWords/:id', component: TAllWordsComponent },
      
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})

export class TopicRoutingModule { }
